import React from "react";
import { Component } from "react";
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import axios from 'axios';
import Select from 'react-select';
import Modal from 'react-modal';

class Register extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            gender: "",
            Gender:"",
            firstName: "",
            lastName: "",
            emailAddress: "",
            mobilePhone: "",
            country: "",
            Country: "",
            City:"",
            city: "",
            userName: "",
            username: "",
            password: "",
            passWord: "",
            businessName: "",
            BusinessName: "",
            registrations: [],
            countryCities: [],
            organisations: [],
        }
    }

    orgs = [];
    genders = [
        { label: "Female", value: "Female" },
        { label: "Male", value: "Male" },
        { label: "Other", value: "Other" }
    ]

    countries = [
        { label: "Angola", value: "Angola" },
        { label: "Cote d'Ivoire", value: "Cote d'Ivoire" },
        { label: "Congo Democratic", value: "Congo Democratic" },
        { label: "Congo Republic", value: "Congo Republic" },
        { label: "Ghana", value: "Ghana" },
        { label: "South Africa", value: "South Africa" },
        { label: "Zimbabwe", value: "Zimbawe" },
    ]

    countriesCities = [
        { label: "Angola", value: "Luanda" },
        { label: "Angola", value: "Cubango" },
        { label: "Cote d'Ivoire", value: "Abidjan" },
        { label: "Congo Democratic", value: "Kinshasa" },
        { label: "Congo Democratic", value: "Lubumbashi" },
        { label: "Congo Democratic", value: "Mbuji Mayi" },
        { label: "Congo Republic", value: "Brazzaville" },
        { label: "Congo Republic", value: "Pointe Noire" },
        { label: "Congo Republic", value: "Dolisie" },
        { label: "Congo Republic", value: "Nkayi" },
        { label: "Congo Republic", value: "Ouesso" },
        { label: "Ghana", value: "Accra" },
        { label: "South Africa", value: "Johannesburg" },
        { label: "South Africa", value: "Cape Town" },
        { label: "South Africa", value: "Tswane" },
        { label: "South Africa", value: "Limpopo" },
        { label: "South Africa", value: "East London" },
        { label: "South Africa", value: "Durban" },
        { label: "South Africa", value: "Port Elizabeth" },
        { label: "Zimbabwe", value: "Bulawayo" },
        { label: "Zimbabwe", value: "Harare" }
    ]


    handleRegisterClose = () => {
        this.setState({
            open: false, firstName: "", lastName: "", emailAddress: "", mobilePhone: "", Country:"", City:"", Gender:"",
            gender: "", userName: "", passWord: "", businessName: "", country: "", city: "", register:""
        });
        document.getElementById('successRegstration').style.display = "none";
        document.getElementById('failRegstration').style.display = "none";
        this.props.onRegisterClose();
        // this.props.loadProduct();
    };
    componentDidMount = async () => {
        this.getAllRegistrations();
        this.getAllOrgs();

    }
    titleCase = (str) => {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    }

    getCountryCities = (country) => {

        let countryCity = [];
        {
            this.countriesCities.map(item => {
                var obj = {};
                if (item.label === country) {
                    obj["label"] = item.value;
                    obj["value"] = item.value;
                    countryCity.push(obj)
                }
            })
        }
        this.setState({ countryCities: countryCity });
    }

    setUserName = (e) => {
        this.setState({
            emailAddress: e.target.value, username: e.target.value
        });
    };

    setPassword = (e) => {
        this.setState({
            passWord: e.target.value, password: e.target.value
        });
    };

    handleRegisterOpen = () => {
        this.setState({ open: true });
    };
    setGenderChange = (e) => {        
        this.setState({Gender:e, gender: e.label });
    }
    setFirstName = (e) => {
        this.setState({ firstName: this.titleCase(e.target.value) });
        //console.log(this.titleCase(e.target.value))
    }
    setLastName = (e) => {
        this.setState({ lastName: this.titleCase(e.target.value) });
    }
    setPhoneNumber = (e) => {
        this.setState({ mobilePhone: e.target.value });
    }
    setBusinessName = (e) => {        
        this.setState({ businessName: e, BusinessName:e.label });
    }
    setCountry = (e) => {
        //console.log(e)
        this.setState({ Country:e.label, country: e });
        this.getCountryCities(e);
    }
    setCity = (e) => {
        //.log(e)
        this.setState({City:e.label, city: e });
    }

    saveRegistration = async (e) => {
        e.stopPropagation();
        this.sendRegistration();
    }
    getAllRegistrations = async (e) => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "social" }

        }
        // const url = "http://localhost/kimvuka-php/api/getAllusers.php";
        const url = "https://testmembership.bktsystems.com/api/getAllusers.php";
        const response = await axios.get(url, config);
       //  console.log(response.data);
        this.setState({ registrations: response.data });
    }

    getAllOrgs = async (e) => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "social" }

        }
        //const url = "http://localhost/kimvuka-php/api/getAllOrgs.php";
        const url = "https://testmembership.bktsystems.com/api/getAllOrgs.php";
        const orgresponse = await axios.get(url, config);
        //console.log(orgresponse.data);
        this.setState({ organisations: orgresponse.data });

        orgresponse.data.map(key => {
            this.orgs.push({
                label: key.name, value: key.name
            });
        })
    }

    sendRegistration = async (e) => {
        let userFound = false;
        //console.log('------'+this.state.city)
        // if(this.state.registrations.length > 0){
        if (Array.isArray(this.state.registrations)) {
            if (this.state.emailAddress !== "") {
                this.state.registrations.map(item => {
                    if ((item.emailaddress.replace(/\s/g, '').toLowerCase() === this.state.emailAddress.replace(/\s/g, '').toLocaleLowerCase())
                        && (item.businessname === this.state.businessName)) {
                        return userFound = true;
                    }

                })
            }
        }
        

        if (userFound === true) {
            alert("Registration with this user account exists for the group already!");
            this.setState({ firstName: "", lastName: "", emailAddress: "", mobilePhone: "", gender: "", userName: "", passWord: "", businessName: "", country: "", city: "" });
            return false;
        }
        else {
            if ((this.state.gender === "") || (this.state.firstName === "") || (this.state.emailAddress === "") || (this.state.mobilePhone === "")
                || (this.state.businessName === "") || (this.state.passWord === "") || (this.state.city === "") || (this.state.country === "")) {
                alert("Please provide all required fields!")
                return false;
            }
            else {

                let config = {
                    headers: { 'Accept': 'application/json' },
                    params: {
                        'firstname': this.state.firstName,
                        'lastname': this.state.lastName,
                        'emailaddress': this.state.emailAddress,
                        'mobilephone': this.state.mobilePhone,
                        'gender': this.state.gender,
                        'username': this.state.userName,
                        'password': this.state.passWord,
                        'businessname': this.state.businessName,
                        'country': this.state.country,
                        'city': this.state.city

                    }
                }
                
                //const url = "http://localhost/kimvuka-php/api/getRegister.php";
                const url = "https://testmembership.bktsystems.com/api/getRegister.php";
                const response = await axios.get(url, config
                )
                // console.log(response.data);
                
                if (response.data.includes("Registration sucessfully received.") || response.data.includes("Registration sucessfully received") === true) {
                    this.setState({ firstName: "", lastName: "", emailAddress: "", mobilePhone: "", gender: "", userName: "", passWord: "", businessName: "", 
                        BusinessName:"", Country:"", City:"", country: "", city: "" });
                    document.getElementById('successRegstration').style.display = "block";
                    document.getElementById('btnSubmit').style.display = 'none';
                    //alert("Thank you, your registration request has been received. We will contact you once your account is setup.");
                }
                else {
                    //alert("There was an error, please try again later.");
                    document.getElementById('failRegstration').style.display = "block";
                }
            }
        }
    }

    render() {

        return (

            <Modal ariaHideApp={false} isOpen={this.state.open} onClose={this.handleRegisterClose}>
                <Form >
                    <div className="mainDivHome" style={{ border: '2px solid rgb(89, 100, 95)', borderRadius: "10px" }}>
                        <div style={{ textAlign: "center" }}><Label> <h4>SIGN UP</h4></Label></div>                                                                <FormGroup>
                            <Label for='gender'>Gender</Label>
                            <Select
                                options={this.genders}
                                maxMenuHeight="100%"
                                defaultInputValue=""
                                onChange={this.setGenderChange}
                             value = {this.state.Gender}
                            ></Select>
                        </FormGroup>
                        <FormGroup>
                            <Label for='firstname'>First name</Label>
                            <Input
                                type='text'
                                id='firstName'
                                name='firstName'
                                value={this.state.firstName}
                                onChange={this.setFirstName}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for='lastname'>Last name</Label>
                            <Input
                                type='text'
                                id='lastName'
                                name='lastName'
                                value={this.state.lastName}
                                onChange={this.setLastName}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for='phonenumber'>Phone Number</Label>
                            <Input
                                type='number'
                                id='phonenumber'
                                name='phonenumber'
                                placeholder="+271234567896"
                                value={this.state.mobilePhone}
                                onChange={this.setPhoneNumber}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="username">E-mail address</Label>
                            <Input
                                id="userName"
                                name="userName"
                                placeholder="Enter e-mail address"
                                onChange={this.setUserName}
                                type="email"
                                value={this.state.emailAddress}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="password">Set Password</Label>
                            <Input
                                id="password"
                                name="password"
                                 placeholder="Set password"
                                onChange={this.setPassword}
                                type="password"
                                value={this.state.passWord}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for='business'>Group name</Label>
                            <Select
                                options={this.orgs}
                                maxMenuHeight="100%"
                                defaultInputValue=""
                                onChange={opt=>this.setBusinessName(opt.label)}
                                value={this.state.BusinessName}
                            ></Select>
                        </FormGroup>

                        <FormGroup>
                            <Label for='country'>Country of residence</Label>
                            <Select
                                options={this.countries}
                                maxMenuHeight="100%"
                                defaultInputValue=""
                                onChange={opt => this.setCountry(opt.label)}
                                value ={this.state.Country}
                            ></Select>
                        </FormGroup>
                        <FormGroup>
                            <Label for='city'>City of residence</Label>
                            <Select
                                options={this.state.countryCities}
                                maxMenuHeight="100%"
                                defaultInputValue=""
                                onChange={opt => this.setCity(opt.label)}
                                value={this.state.City}
                            ></Select>
                        </FormGroup>
                        <div id='successRegstration' style={{ textAlign: "center", color: "green", display: "none" }}><Label> <h4>Registration sent, thank you!</h4></Label></div>
                        <div id='failRegstration' style={{ textAlign: "center", color: "red", display: "none" }}><Label> <h4>Registration failed!</h4></Label></div>
                        <div id="btnSubmit" style={{ paddingTop: "20px" }}>
                            <Button style={{ backgroundColor: "rgb(9, 59, 16)", width: "100%", fontWeight: "bold", color: "white" }} type="submit" onClick={this.saveRegistration}>Submit</Button>
                        </div>
                        <div style={{ paddingTop: "20px" }}>
                            <Button style={{ width: "100%", fontWeight: "bold" }}
                                onClick={this.handleRegisterClose}>
                                Close
                            </Button>
                        </div>
                    </div>
                </Form>
            </Modal>

        );

    }

}
export default Register